import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CompanyAccess } from '../../data-services';
import { DynamicDialogRef, DynamicDialogConfig, SelectItem } from '../../shared';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-company-access-dialog',
    templateUrl: './company-access-dialog.component.html',
    styleUrls: ['./company-access-dialog.component.scss'],
    standalone: false
})
export class CompanyAccessDialogComponent implements OnInit {
    companyFormGroup: UntypedFormGroup;
    companies: SelectItem[];

    constructor (public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private log: LoggingService) {
        this.companies = (config.data.companies as CompanyAccess.CompanyAccessModel[])
            .map(x => ({
                value: x.id,
                label: `${x.customername} - ${x.contactname}(${x.contactemail})`
            }));
        this.companyFormGroup = new UntypedFormGroup({
            company: new UntypedFormControl(null, Validators.required)
        });
    }

    ngOnInit(): void { }
    onSave(form): void {
        this.log.verbose({
            type: 'CompanyAccessDialogComponent:onSave',
            form
        });
        this.dialogRef.close(form);
    }
    onCancel(): void {
        this.dialogRef.close();
    }
}
